module.exports = __webpack_public_path__ + "fonts/SourceHanSansCN-Medium.6c9e4f2a.ttf";